import { FC } from 'react'

import TrainingPersonRequirementsFormFields from './training-person-requirements-form-fields'

import { ITrainingPersonRequirementsFormProps } from './training-person-requirements-form-types'

import s from '../../../../features/admin-training/admin-training.module.scss'

const TrainingPersonRequirementsForm: FC<ITrainingPersonRequirementsFormProps> = props => {
  const { handleSubmit, formName, submitting, isUpdateMode = false } = props

  return (
    <form onSubmit={handleSubmit} id={formName}>
      {!isUpdateMode && (
        <div className={`${s['container-gray']} border rounded p-4`}>
          Select the training types required for this person. If they belong to a personnel group with requirements,
          those will appear here and can be added all at once using the "Add All Group Reqs" button.
          <br />
          <br />
          New requirements added will default to an effective start date of the person's start date, if available, or
          today's date otherwise. These dates can be adjusted in the Actions column of the table afterwards.
        </div>
      )}

      <TrainingPersonRequirementsFormFields disabled={submitting} isUpdateMode={isUpdateMode} />
    </form>
  )
}

export default TrainingPersonRequirementsForm
